PJQ.views.drawings.DrawingUploadLogModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Upload-Log'),
        width: 800,
        maxWidth: '90%'
    },
    events: {
        'click .btn-revert-batch': 'revertBatch',
        'click .btn-notify': 'notify',
        'click .btn-publish-batch': 'publishBatch',
        'click .btn-delete-batch': 'deleteBatch',
        'click .btn-new-batch': 'newBatch',
        'click .btn-close': 'close'
    },
    beforeModalCreated: function () {
        this.collection = new PJQ.collections.drawings.DrawingBatches(null, {
            project: this.options.project
        });
        this.collection.fetch({
            success: _.bind(function () {
                this.render();
                this.listenTo(this.collection, 'fetch', this.render);
            }, this)
        });
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.upload-log'),
            data: this.collection.models,
            language: {
                zeroRecords: 'Click "Upload Drawings" to publish a new version'
            },
            isHideSearch: true,
            order: [3, 'desc'],
            columns: [
                {
                    "data": "attributes.drawingCount",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('status') === 2) {
                            return '<div class="text-orange fs-16"><i class="fad fa-file"></i> ' + data.toString() + '</div>';
                        }
                        return '';
                    }, this),
                    "title": "",
                    "width": "50px"
                },
                {"data": "attributes.versionName", "title": "Version", "orderable": true},
                {
                    "data": "createdBy",
                    "render": _.bind(function (data) {
                        return PJQ.helpers.contacts.getContactAnchor({id: -data.id, name: data.get('companyName')});
                    }, this),
                    "title": "Created By"
                },
                {
                    "data": {
                        "_": function (row) {
                            return new Date(row.get('createdOn'));
                        },
                        "filter": "attributes.createdOn",
                        "display": function (row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }
                    },
                    "title": "Created On",
                    "width": "150px"
                },
                {
                    "data": "attributes.isPublished",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let status = row.get('status'),
                            content;
                        if (status === 0 || status === 1) {
                            content = '<span class="text-info fs-16 font-weight-light">Processing...</span>';
                        } else if (status === 2 && row.get('isPublished')) {
                            let btn = `<div class="btn-group">
                                <button type="button"
                                        class="btn btn-light dropdown-toggle btn-sm ml-2" data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                    <i class="fad fa-ellipsis-v ml-1"></i>
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item btn-notify" title="Save these project action items as a template"
                                       href="javascript:void(0)">Send Notifications</a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item btn-revert-batch" title="Import system template to this project"
                                       href="javascript:void(0)">Un-Publish</a>
                                </div>
                            </div>`;
                            // let btn = '<button type="button" title="Revert" class="btn btn-light ml-2 btn-revert-batch"><i class="fad fa-undo"></i></button>';
                            content = '<span class="text-success fs-16 font-weight-light">Published</span>' + btn;
                        } else {
                            content = '<button type="button" class="btn btn-sm btn-success btn-publish-batch mr-1">Publish</button><button type="button" class="btn btn-sm btn-danger btn-delete-batch">Delete</button>';
                        }
                        return '<div class="text-align-center">' + content + '</div>';
                    }, this),
                    "width": '150px'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

        _.each(this.collection.models, _.bind(function (batch) {
            this.checkBatchStatus(batch)
        }, this));
    },
    checkBatchStatus: function (batch) {
        if (batch.get('status') === 0 || batch.get('status') === 1) {
            batch.statusTimeout = setTimeout(_.bind(function () {
                batch.fetchStatus(_.bind(function (status) {
                    if (status === 2) {
                        // we want to fetch the batch now to get the correct drawing count
                        this.collection.fetch({
                            success: _.bind(function () {
                                this.dataTable.refresh();
                            }, this)
                        });
                        return;
                    }
                    this.checkBatchStatus(batch);
                }, this));
            }, this), 3000)
        }
    },
    notify: function (e) {
        this.removeModal();

        let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
            batch = row.data();
        new PJQ.views.drawings.BatchNotifyModal({
            batch: batch,
            versions: this.options.versions
        });
    },
    revertBatch: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
            batch = row.data();
        new PJQ.views.modals.YesNo({
            header: "Revert Upload",
            body: "Are you sure you want to revert?  This will un-publish all of the drawings in this upload.",
            onYes: _.bind(function () {
                batch.save(null, {
                    urlOptions: {
                        revert: true
                    },
                    success: _.bind(function () {
                        batch.set('isPublished', false);
                        this.dataTable.refresh();
                        this.options.versions.fetch({
                            success: _.bind(function () {
                                PJQ.notifications.notify.successNotify({
                                    message: 'Drawing upload reverted'
                                });
                            }, this)
                        });
                    }, this)
                });
            }, this)
        });
    },
    publishBatch: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
            batch = row.data();
        this.close();
        new PJQ.views.drawings.DrawingBatchModal({
            model: batch,
            versions: this.options.versions,
            project: this.options.project
        });
    },
    deleteBatch: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            batch = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Upload",
            body: "Are you sure you want to delete this upload?",
            onDelete: _.bind(function () {
                batch.destroy({
                    success: _.bind(function () {
                        this.collection.remove(batch);
                        this.dataTable.removeRow(row);
                    }, this)
                });
            }, this)
        });
    },
    newBatch: function () {
        this.close();
        new PJQ.views.drawings.DrawingBatchModal({
            versions: this.options.versions,
            project: this.options.project
        });
    },
    close: function () {
        this.removeModal();
        _.each(this.collection.models, _.bind(function (batch) {
            if (batch.statusTimeout != null) {
                clearTimeout(batch.statusTimeout);
                batch.statusTimeout = null;
            }
        }, this));
    }
});

PJQ.views.drawings.SortDrawings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Sort-Drawings'),
        onChange: null,
        showViewLink: true,
        batch: null,
        sortFullSet: false
    },
    events: {
        'click .btn-view-drawing': 'viewDrawing',
        'click .btn-sort-common': 'sortCommon',
        'click .btn-sort-alpha-num': 'sortAlphaNumeric',
        'click .btn-sort-up': 'sortDrawingUp',
        'click .btn-sort-down': 'sortDrawingDown',
        'click .btn-sort-top': 'sortTop',
        'click .btn-sort-bottom': 'sortBottom'
    },
    beforeFirstRender: function () {
        this.sortDrawings = [];
        this.fullset = [];
        let mergeCurrentSet = false;
        if (this.options.batch != null) {
            let hasCurrentSetChange = !this.options.batch.get('replaceCurrentSet') && null != this.options.batch.drawings.findWhere({
                isCurrentSet: true,
                isPublished: false
            });

            if (!hasCurrentSetChange) {
                this.options.batch.drawings.reset(this.options.batch.drawings.where({isPublished: false}));
            } else {
                mergeCurrentSet = true;
            }

            _.each(this.options.batch.drawings.models, function (drawing) {
                if (!drawing.get('isDeleted')) {
                    this.fullset.push(drawing);
                    this.sortDrawings.push({
                        drawing: drawing,
                        matches: []
                    });
                }
            }, this);

            _.each(this.sortDrawings.toReversed(), function (sortDrawing, index) {
                sortDrawing.drawing.set('sortOrder', index * -1);
            });

        } else if (this.options.sortVersion != null) {
            let curSet = this.options.versions.get(-1);
            if (curSet) {
                mergeCurrentSet = null != _.find(this.options.sortVersion.drawings.models, (sDrawing) => {
                    return curSet.drawings.findWhere({name: sDrawing.get('name')});
                });
            }
            else
                mergeCurrentSet = false;
        } else {
            mergeCurrentSet = true;
        }

        if (this.options.sortVersion != null && !mergeCurrentSet) {
            _.each(this.options.sortVersion.drawings.models, (drawing) => {
                this.sortDrawings.push({
                    drawing: drawing,
                    matches: []
                });
                this.fullset.push(drawing);
            });
        } else {
            let self = this,
                curSet = self.options.versions.get(-1);
            if (curSet != null) {
                _.each(curSet.drawings.models, function (drawing) {
                    let sortItem = _.find(self.sortDrawings, function (sortItem) {
                        return drawing.get('name') === sortItem.drawing.get('name');
                    });
                    if (sortItem != null) {
                        sortItem.matches.push(drawing);
                        sortItem.drawing.set('sortOrder', drawing.get('sortOrder'));
                    } else {
                        self.fullset.push(drawing);
                        self.sortDrawings.push({
                            drawing: drawing,
                            matches: []
                        });

                        if (self.options.batch != null) {
                            // we have to add this drawing to the batch so it gets saved with the new sort order
                            // it will save across all by name if the drawing being updated is already published
                            self.options.batch.drawings.add(drawing);
                        }
                    }
                });
            }

            _.each(self.options.versions.models, function (version) {
                _.each(version.drawings.models, function (drawing) {
                    if (!drawing.get('isDeleted')) {
                        let sortItem = _.find(self.sortDrawings, function (sortItem) {
                            return drawing.get('name') === sortItem.drawing.get('name');
                        });
                        if (sortItem != null) {
                            sortItem.matches.push(drawing);
                        } else if (self.options.sortFullSet) {
                            self.fullset.push(drawing);
                            self.sortDrawings.push({
                                drawing: drawing,
                                matches: []
                            });

                            if (self.options.batch != null) {
                                // we have to add this drawing to the batch so it gets saved with the new sort order
                                // it will save across all by name if the drawing being updated is already published
                                self.options.batch.drawings.add(drawing);
                            }
                        }
                    }
                });
            });

            // iterate through each of the models in order of their sort order and e-set their sort order
            // this is to ensure they are sequential with no gaps or duplicates
            if (self.options.batch != null) {
                let drawingsSorted = _.sortBy(self.options.batch.drawings.models, function (drawing) {
                    return drawing.get('sortOrder');
                });
                for (let i = 0; i < drawingsSorted.length; i++) {
                    drawingsSorted[i].set('sortOrder', i + 1);
                }
            }
        }
    },
    renderData: function () {
        return {
            showViewLink: this.options.showViewLink,
            sortDrawings: this.fullset,
            contextDrawing: this.options.contextDrawing
        };
    },
    afterRender: function () {
        let self = this;
        self.drawingSortable = new PJQ.Sortable(self.$('.drawings-sort'), {
            containment: "parent",
            items: '.drawing-sort',
            multiple: true,
            connectWith: '.drawing-sort',
            onStop: function () {
                self.setSortLabels();
            }
        });
    },
    setSortLabels: function () {
        let self = this;
        self.$('.drawing-sort').each(function (index) {
            let id = $(this).data('id'),
                item = _.find(self.fullset, function (sortDrawing) {
                    return sortDrawing.id === id
                }),
                name = item.get("name"),
                sortItem = _.find(self.sortDrawings, function (sortDrawing) {
                    return sortDrawing.drawing.get('name') === name
                }),
                sortOrder = index + 1;

            sortItem.drawing.set('sortOrder', sortOrder);
            _.each(sortItem.matches, function (match) {
                match.set('sortOrder', sortOrder);
            });
            $(this).find('.sort-index').html(sortOrder.toString() + '.');
        });
        this.onChange();
    },
    viewDrawing: function (e) {
        let drawingId = $(e.currentTarget).closest('.drawing-sort').data('id'),
            drawing = _.find(this.fullset, function (d) {
                return d.id === drawingId;
            });
        new PJQ.views.drawings.DrawingViewer({
            model: drawing,
            contextVersion: this.options.versions.get(drawing.get('versionId')),
            batch: this.options.batch,
            versions: this.options.versions,
            onSortChange: _.bind(function () {
                this.onChange();
                this.render();
            }, this)
        });
    },
    sortCommon: function () {
        this.autoSort('common');
    },
    sortAlphaNumeric: function () {
        this.autoSort('alpha');
    },
    autoSort: function (type) {
        switch (type) {
            case 'common':
                this.fullset = this.fullset.sort(function (a, b) {
                    return PJQ.helpers.sortHelpers.sortCommonPageNumbers(a.get('name'), b.get('name'));
                });
                break;
            case 'alpha':
                this.fullset = this.fullset.sort(function (a, b) {
                    return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('name'), b.get('name'));
                });
                break;
        }

        _.each(this.fullset, function (drawing, index) {
            let sortItem = _.find(this.sortDrawings, function (sortDrawing) {
                    return sortDrawing.drawing.get('name') === drawing.get('name');
                }),
                sortOrder = index + 1;
            sortItem.drawing.set('sortOrder', sortOrder);
            _.each(sortItem.matches, function (match) {
                match.set('sortOrder', sortOrder);
            });
        }, this);
        this.onChange();
        this.render();
    },
    sortDrawingUp: function (e) {
        let $drawing = $(e.currentTarget).closest('.drawing-sort');
        $drawing.insertBefore($drawing.prev());
        this.setSortLabels();
    },
    sortDrawingDown: function () {
        let $drawing = $(e.currentTarget).closest('.drawing-sort');
        $drawing.insertAfter($drawing.next());
        this.setSortLabels();
    },
    sortTop: function () {
        this.drawingSortable.moveSelectedTop();
    },
    sortBottom: function () {
        this.drawingSortable.moveSelectedBottom();
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange();
        }
    }
});

PJQ.views.drawings.SortDrawingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Sort-Drawings'),
        width: 600,
        maxWidth: '90%',
        onDone: _.noop,
        sortFullSet: false
    },
    events: {
        'click .btn-done': 'done'
    },
    afterRender: function () {
        new PJQ.views.drawings.SortDrawings({
            el: this.$('.sort-drawings'),
            versions: this.options.versions,
            sortVersion: this.options.sortVersion,
            batch: this.options.batch,
            sortFullSet: this.options.sortFullSet
        });
    },
    done: function () {
        if (typeof this.options.onDone === 'function') {
            this.options.onDone();
        }
        this.removeModal();
    }
});

PJQ.views.drawings.AdvancedDownloadModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Advanced-Download'),
        width: 500,
        maxWidth: '90%',
        onDone: _.noop
    },
    events: {
        'click .btn-download': 'download'
    },
    renderData: function () {
        return {
            project: this.options.project,
            isPaidDownload: this.options.isPaidDownload,
            isPrintOrder: this.options.isPrintOrder
        };
    },
    afterRender: function () {
        if (this.options.isPrintOrder) {
            this.$('.context-title').text('Order Prints')
            this.$('.btn-download').text('Continue');
        }

        this.renderDrawingSelector();
    },
    renderDrawingSelector: function () {
        new PJQ.views.drawings.DrawingSelectorTree({
            el: this.$('.drawings-tree'),
            collection: this.collection,
            onChange: _.bind(function (versions) {
                this.selectedVersions = versions;

                let selDrawingCount = 0;
                _.each(versions, function (version) {
                    selDrawingCount += _.size(version.guids);
                });
                this.$('.btn-download').prop('disabled', selDrawingCount === 0);
            }, this)
        });
    },
    download: function () {
        let raster = this.$('.checkbox-raster').prop('checked'),
            merge = this.$('.checkbox-merge').prop('checked'),
            includeAttachments = this.$('.checkbox-attachments').prop('checked'),
            includeMyAnnotations = this.$('.checkbox-my-annotations').prop('checked'),
            includePublishedAnnotations = this.$('.checkbox-published-annotations').prop('checked');

        let dl = _.bind(function () {
            let entryIds = [];
            _.each(this.selectedVersions, function (selectedVersions) {
                entryIds.push(..._.map(selectedVersions.ids, function (id) {
                    return id * -1;
                }));
            });
            if (this.options.isPaidDownload) {
                if (PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.CAN_ORDER_ON_ACCOUNT) || PJQ.app.session.hasPermission('documents.onAccount'))) {
                    new PJQ.views.drawings.OrderDownloadAdmin({
                        entryIds: entryIds,
                        orderSettings: this.options.orderSettings
                    });
                } else {
                    new PJQ.views.drawings.OrderPrintsModal({
                        mode: PJQ.constants.files.modes.DOWNLOAD,
                        entryIds: entryIds,
                        orderSettings: this.options.orderSettings
                    });
                }
            } else if (this.options.isPrintOrder) {
                new PJQ.views.drawings.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.PRINT,
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            } else {
                PJQ.helpers.drawings.createDownload(this.options.project, this.selectedVersions, {
                    raster: raster,
                    merge: merge,
                    includeAttachments: includeAttachments,
                    includeMyAnnotations: includeMyAnnotations,
                    includePublishedAnnotations: includePublishedAnnotations
                });
            }
        }, this);
        if (this.options.project != null) {
            this.options.project.checkDownloadRequirements(_.bind(function () {
                dl();
                this.removeModal();
            }, this));
        } else {
            dl();
        }
    }
});

PJQ.views.drawings.ManageVersionsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Manage-Versions'),
        width: 600,
        maxWidth: '90%'
    },
    events: {
        'click .btn-upload-to-version': 'uploadToVersion',
        'click .btn-new-batch': 'newBatch',
        'click .btn-sort-version': 'sortVersion',
        'click .btn-edit-version': 'editVersion',
        'click .btn-cancel-edit-version': 'cancelEditVersion',
        'click .btn-delete-version': 'deleteVersion',
        'click .btn-save-version': 'saveVersion',
        'click .btn-close': 'close'
    },
    beforeModalCreated: function () {
        if (this.collection == null) {
            this.collection = new PJQ.collections.drawings.Versions(null, {
                project: this.options.project
            });
            this.collection.fetch({
                success: _.bind(function () {
                    this.render();
                }, this)
            });
        }
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.upload-log'),
            data: _.filter(this.collection.models, function (version) {
                return version.id > 0;
            }),
            language: {
                zeroRecords: 'Click "Upload Drawings" to publish a new version'
            },
            onTableDraw: _.bind(function () {
                if (this.contextEditVersion != null) {
                    this.datePicker = new PJQ.inputs.Datepicker({
                        el: this.$('.input-version-date-issued'),
                        isShowTimezone: false,
                        datepickerOptions: {
                            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
                        },
                        onChange: _.bind(function (newDate) {
                            this.contextEditVersion.set('issuedOn', newDate);
                        }, this)
                    });
                }
            }, this),
            isHideSearch: true,
            order: [1, 'desc'],
            columns: [
                // {
                // 	"data": "attributes.drawings",
                // 	"render": _.bind(function (data, type, row) {
                // 		let drawingCount = _.size(row.drawings);
                // 		if (drawingCount > 0) {
                // 			return '<div class="text-orange fs-16"><i class="fad fa-file"></i> ' + drawingCount.toString() + '</div>';
                // 		}
                // 		else {
                // 			return '<div class="text-muted fs-16"><i class="fad fa-file"></i> ' + drawingCount.toString() + '</div>';
                // 		}
                // 	}, this),
                // 	"title": "",
                // 	"width": "50px"
                // },
                {
                    "data": {
                        "_": function (row) {
                            return new Date(row.get('name'));
                        },
                        "filter": "attributes.name",
                        "display": _.bind(function (row) {
                            if (this.contextEditVersion != null && this.contextEditVersion.id === row.id) {
                                return '<input type="text" class="form-control input-version-name" value="' + row.get('name') + '">';
                            } else {
                                return row.get('name');
                            }
                        }, this)
                    },
                    "title": "Version Name"
                },
                {
                    "data": {
                        "_": function (row) {
                            return new Date(row.get('issuedOn'));
                        },
                        "filter": "attributes.issuedOn",
                        "display": _.bind(function (row) {
                            if (this.contextEditVersion != null && this.contextEditVersion.id === row.id) {
                                return '<input type="text" class="form-control input-version-date-issued" value="' + row.get('issuedOn') + '" />';
                            } else {
                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('issuedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                            }
                        }, this)
                    },
                    "title": "Issued On",
                    "width": "100px"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.contextEditVersion != null && this.contextEditVersion.id === row.id) {
                            content = '<button type="button" class="btn btn-success btn-save-version wd-30p mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-version wd-30p"><i class="fal fa-times"></i></button>';
                        } else {
                            let disabledAttr = this.contextEditVersion != null ? ' disabled ' : '';
                            content = '<button type="button" title="Upload Drawings" class="btn btn-success btn-upload-to-version wd-30p mr-1"' + disabledAttr + '><i class="fal fa-file-plus"></i></button><button type="button" class="btn btn-info btn-edit-version wd-30p mr-1"' + disabledAttr + '><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger btn-delete-version wd-30p"' + disabledAttr + '><i class="fal fa-trash"></i></button>';
                        }
                        return '<div class="text-align-right">' + content + '</div>'
                    }, this),
                    "width": '100px'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    newBatch: function () {
        this.close();
        new PJQ.views.drawings.DrawingBatchModal({
            versions: this.collection,
            project: this.options.project
        });
    },
    uploadToVersion: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            version = this.dataTable.getRow($row).data();
        this.close();
        new PJQ.views.drawings.DrawingBatchModal({
            version: version,
            project: this.options.project,
            versions: this.collection
        });
    },
    editVersion: function (e) {
        this.contextEditVersion = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
        this.dataTable.refresh();
    },
    cancelEditVersion: function () {
        this.contextEditVersion = null;
        this.dataTable.refresh();
    },
    saveVersion: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            version = this.dataTable.getRow($row).data(),
            $name = $row.find('.input-version-name');
        version.set('name', $name.val());

        let isNameValid = _.size(version.get('name')) > 0;
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);

        let isIssuedOnValid = version.get('issuedOn') != null;
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-version-date-issued'), isIssuedOnValid);

        if (isNameValid && isIssuedOnValid) {
            version.save(null, {
                success: _.bind(function () {
                    this.contextEditVersion = null;
                    this.dataTable.refresh();
                }, this)
            });
        }
    },
    deleteVersion: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            version = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Version",
            body: "Are you sure you want to delete this version?",
            onDelete: _.bind(function () {
                version.destroy({
                    success: _.bind(function () {
                        this.collection.remove(version);
                        this.dataTable.removeRow(row);
                    }, this)
                });
            }, this)
        });
    },
    close: function () {
        this.removeModal();
        _.each(this.collection.models, _.bind(function (batch) {
            if (batch.statusTimeout != null) {
                clearTimeout(batch.statusTimeout);
                batch.statusTimeout = null;
            }
        }, this));
    }
});

PJQ.views.drawings.BatchNotifyModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'modal-batch-notify'),
        subTemplates: {
            emailBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Share-Email-Badge')
        },
        maxWidth: 650,
    },
    events: {
        'click .btn-back': 'previousStep',
        'click .btn-next': 'nextStep',
        'click .btn-send': 'send',
        'click .btn-cancel': 'cancel',
        'click .btn-add-project-contacts': 'addProjectContacts',
        'keyup .input-share-search': 'searchChanged',
        'focus .input-share-search': 'focusSearch',
        'click .share-email-delete': 'deleteEmail',
        'mousedown .modal-dialog': 'checkIsFocused'
    },
    beforeModalCreated: async function () {
        if (this.options.project == null) {
            this.options.project = PJQ.app.session.project;
        }

        this.isFetched = false;
        this.step = 1;

        this.selectedEmailsTo = [];
        this.selectedEmailsCC = [];

        let verAppend = null;
        if (this.options.versions != null) {
            let version = this.options.versions.get(this.options.batch.get('versionId'));
            if (version != null) {
                verAppend = ' (' + version.get('name') + ')';
            }
        }

        this.model = new PJQ.models.drawings.DrawingBatchNotification({
            batchId: this.options.batch.id,
            subject: 'Drawings Published to ' + this.options.project.get('projectName') + (verAppend ?? ""),
            message: ''
        });

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            step: this.step,
            batch: this.options.batch,
            selectedEmailsTo: this.selectedEmailsTo,
            selectedEmailsCC: this.selectedEmailsCC
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.StepIndicator(this.$('.steps-outer'), {
            steps: [{
                name: 'Compose Email'
            }, {
                name: 'Review & Send'
            }],
            activeStep: this.step - 1
        });

        switch (this.step) {
            case 1:
                this.bodyEditor = new PJQ.inputs.HTMLEditor({
                    el: this.$('.email-message'),
                    editorHeight: 300,
                    isHideTokens: true,
                    onChange: (contents) => {
                        this.model.set('message', contents);
                    }
                });

                _.each(this.selectedEmailsTo, (email) => {
                    this.renderEmail(email, 'to');
                });

                _.each(this.selectedEmailsCC, (email) => {
                    this.renderEmail(email, 'cc');
                })
                break;
            case 2:
                break;
            case 3:
                break;
        }
    },
    addProjectContacts: function () {
        this.selector = new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            enableSelectAll: true,
            isSingleChoice: false,
            // saveButtonText: this.options.saveButtonText,
            onSave: (newContacts) => {
                let emails = _.filter(_.map(newContacts, (contact) => {
                    return contact.get('email');
                }), (email) => {
                    return _.size(email) > 0;
                });
                _.each(emails, (email) => {
                    if (_.contains(this.selectedEmailsTo, email)) {
                        return;
                    }
                    this.selectedEmailsTo.push(email);
                    this.renderEmail(email, 'to');
                });
            }
        });
    },
    previousStep: function () {
        this.step--;
        this.render();
    },
    nextStep: function () {
        switch (this.step) {
            case 1:
                let toValid = _.size(this.selectedEmailsTo) > 0;
                PJQ.helpers.inputHelpers.setInputError(this.$('.input-to'), toValid);

                let subject = this.$('.input-subject').val(),
                    subjectValid = _.size(subject) > 0;
                this.model.set('subject', subject);
                PJQ.helpers.inputHelpers.setInputError(this.$('.input-subject'), subjectValid);

                if (!subjectValid || !toValid) {
                    return;
                }
                break;
            case 2:
                break;
            case 3:
                break;
        }

        this.step++;
        this.render();
    },
    focusSearch: function (e) {
        this.focusType = $(e.currentTarget).data('email-line');
        if (this.contactEmailSelector != null)
            this.contactEmailSelector.remove();

        this.contactEmailSelector = new PJQ.views.email.ContactSearchSelect({
            el: this.focusType === "to" ? this.$('.contact-emails-to') : this.$('.contact-emails-cc'),
            selectedEmails: this.focusType === "to" ? this.selectedEmailsTo : this.selectedEmailsCC,
            search: this.getFocusSearchText(),
            project: this.options.project,
            onAdd: (email) => {
                this.renderEmail(email);
            }
        });
    },
    checkIsFocused: function (e) {
        if (this.$(e.target).closest('.share-contact').length > 0) {
            return;
        }

        // Removes contact email selector if not selecting a contact, or entering an email
        let target = $(e.target),
            targetParent = $(e.target.parentElement);

        if (this.focusType != null
            && !target.hasClass('share-contact')
            && !targetParent.hasClass('share-contact')
            && !target.hasClass('input-share-search')
            && !target.hasClass('share-contact-email')
            && !target.hasClass('share-email-entry')
            && !target.hasClass('share-contact-name')) {
            this.contactEmailSelector.remove();
            this.focusType = null;
        }
    },
    getFocusSearchText: function () {
        return this.focusType != null ? this.$('.input-share-search[data-email-line="' + this.focusType + '"]').val().toLowerCase() : this.$('.input-share-search').val().toLowerCase();
    },
    searchChanged: function () {
        if (this.contactEmailSelector == null) {
            return;
        }

        this.contactEmailSelector.searchChanged(this.getFocusSearchText());
    },
    renderRecipientCount: function () {
        let emailCount = _.size(this.selectedEmailsTo) + _.size(this.selectedEmailsCC);
        this.$('.recipient-count').html(emailCount.toString() + (emailCount === 1 ? ' recipient' : ' recipients'));
    },
    renderEmail: function (email, type = null) {
        this.renderSubTemplate(true, this.options.subTemplates.emailBadge, this.$('.share-selected-emails[data-email-line="' + (type ?? this.focusType) + '"]'), {
            email: email
        });
        this.$('.input-share-search').val('');
        this.$('.modal-share-send').prop('disabled', false);
        this.renderRecipientCount();
        this.$('.input-share-search[data-email-line="' + this.focusType + '"]').focus();
    },
    deleteEmail: function (e) {
        let emailContainer = $(e.currentTarget).closest('.share-email'),
            emailLineType = $(e.currentTarget).closest('.share-selected-emails').data('email-line'),
            emailArray = emailLineType === "to" ? this.selectedEmailsTo : this.selectedEmailsCC
        emailArray = _.without(emailArray, emailContainer.data('email').toLowerCase());

        if (emailLineType === "to")
            this.selectedEmailsTo = emailArray
        else
            this.selectedEmailsCC = emailArray

        emailContainer.remove();
        this.searchChanged();
        this.$('.modal-share-send').prop('disabled', _.size(emailArray) === 0);
        this.renderRecipientCount();
    },
    send: function () {
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.model.set({
            to: this.selectedEmailsTo,
            cc: this.selectedEmailsCC
        })

        this.model.save(null, {
            success: () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Published Drawings Notification sent'
                });
                this.removeModal();
            },
            error: () => {
                PJQ.notifications.notify.errorNotify({
                    message: 'Encountered an error sending notification, please contact customer service'
                });
            },
        });
    },
    cancel: function () {
        new PJQ.views.modals.YesNo({
            header: "Cancel Notification?",
            body: "Are you sure you want to cancel sending this notification?",
            onYes: () => {
                this.removeModal();
            }
        });
    }
});